import { ContentTagEffects } from './content-tag.effect';
export const effects: any[] = [ContentTagEffects];
export * from './content-tag.effect';
